<template>
    <div>
        <div v-for="(paginas, p) in paginasAlumnos" :key="p" :style="{ display: descargaVisible ? 'block' : 'none' }">
            <div class="DescargarActaCalificacionesDocente" style="width: 1240px; height: 1754px; color: black;">
                <div class="content">
                    <h1 class="mb-2">Acta de calificaciones <i><small>({{parametros.periodo}})</small></i></h1>
                
                    <div class="my-2" style="border: 1px solid #D9D9D9; padding: 5px 9px; margin-bottom: 5px;">
                        <vs-row>
                            <vs-col w="4">
                                <p class="fontEight lineTogether" v-if="paginas.params_calificacion"><strong> {{paginas.params_calificacion.docente}}</strong></p>
                            </vs-col>
                            <vs-col w="4">
                                <p class="fontEight lineTogether" style="padding: 0 9px;"><strong>{{parametros.codigo}} </strong></p>
                            </vs-col>
                            <vs-col w="4">
                            </vs-col>
                            <vs-col w="4">
                                <p class="fontEight lineTogether" style="padding-right: 18px;">   {{parametros.institucion}}
                                </p>
                            </vs-col>
                            <vs-col w="4">
                                <p class="fontEight lineTogether">{{parametros.cicloEscolar}}</p>
                            </vs-col>
                            <vs-col w="4">
                                <p class="fontEight lineTogether">GRUPO ACADÉMICO: <span class="text-uppercase">{{parametros.grupoL}}</span></p>
                            </vs-col>
                            <vs-col w="4" v-if="paginas.clases_impartidas">
                                <p class="fontEight lineTogether">NO. DE CLASES IMPARTIDAS: <span class="text-uppercase">{{paginas.clases_impartidas}}</span></p>
                            </vs-col>
                            <vs-col w="4">
                                <p class="fontEight lineTogether" style="padding-right: 18px;">FECHA DE ACTA GENERADA: <span>{{hoy}}</span></p>
                            </vs-col>
                            <vs-col w="4">
                                <p class="fontEight lineTogether">CAPTURADO: <span class="text-uppercase">{{fechaModificacion}}</span></p>
                            </vs-col>
                        </vs-row>
                    </div>
                    
                    <div class="d-flex padding9">
                        <div style="width: 10%" class="fontEight px-1 cabeceraTable">
                            <p style="hyphens: auto;">No. lista </p>
                        </div>
                        <div style="width: 30%" class="fontEight px-1 cabeceraTable">
                            <p style="hyphens: auto;">Nombre </p>
                        </div>
                        <div style="width: 10%" class="fontEight px-1 cabeceraTable">
                            <p style="hyphens: auto;">Grupo admin.</p>
                        </div>
                        <div class="d-flex text-center" style="width: 50%">
                            <div v-if="rubros.calificacion == 'si'" class="fontEight px-1 cabeceraTable" :class="'widthCabecera' + numCabecera">
                                <p style="hyphens: auto;">Calificación</p>
                            </div>
                            <div v-if="rubros.faltas == 'si'" class="fontEight px-1 cabeceraTable" :class="'widthCabecera' + numCabecera">
                                <p style="hyphens: auto;">Faltas</p>
                            </div>
                            <div v-if="rubros.conducta == 'si'" class="fontEight px-1 cabeceraTable" :class="'widthCabecera' + numCabecera">
                                <p style="hyphens: auto;">Conducta</p>
                            </div>
                            <div v-if="rubros.retardos == 'si'" class="fontEight px-1 cabeceraTable" :class="'widthCabecera' + numCabecera">
                                <p style="hyphens: auto;">Retardos</p>
                            </div>
                            <div v-if="rubros.tareas_no_hechas == 'si'" class="fontEight px-1 cabeceraTable" :class="'widthCabecera' + numCabecera">
                                <p style="hyphens: auto;">Tareas no hechas</p>
                            </div>
                        </div>
                    </div>
                    <div class="backgroundCampos p-1" v-for="(alumno, a) in paginas.alumnos" :key="a">
                        <div class="d-flex">
                        <div style="width: 10%" class="fontSix px-1 cabeceraTableCenter ">
                            <p style="hyphens: auto;">{{alumno.no_lista}} </p>
                        </div>
                        <div style="width: 30%" class="fontSix px-1 cabeceraTable">
                            <p style="hyphens: auto;">{{alumno.alumno_name}} </p>
                        </div>
                        <div style="width: 10%" class="fontSix px-1 cabeceraTableCenter ">
                            <p style="hyphens: auto;">{{alumno.grupo_administrativo}}</p>
                        </div>
                        <div v-if="alumno.calificacion" class="d-flex" style="width: 50%">
                            <div  v-if="rubros.calificacion == 'si'" class="fontEight px-1 cabeceraTableCenter" :class="'widthCabecera' + numCabecera">
                                <p style="hyphens: auto;">{{alumno.calificacion.calificacion}}</p>
                            </div>
                            <div v-if="rubros.faltas == 'si'" class="fontEight px-1 cabeceraTableCenter" :class="'widthCabecera' + numCabecera">
                                <p style="hyphens: auto;">{{alumno.calificacion.faltas}}</p>
                            </div>
                            <div v-if="rubros.conducta == 'si'" class="fontEight px-1 cabeceraTableCenter" :class="'widthCabecera' + numCabecera">
                                <p style="hyphens: auto;">{{alumno.calificacion.conducta}}</p>
                            </div>
                            <div v-if="rubros.retardos == 'si'" class="fontEight px-1 cabeceraTableCenter" :class="'widthCabecera' + numCabecera">
                                <p style="hyphens: auto;">{{alumno.calificacion.retardos}}</p>
                            </div>
                            <div v-if="rubros.tareas_no_hechas == 'si'" class="fontEight px-1 cabeceraTableCenter" :class="'widthCabecera' + numCabecera">
                                <p style="hyphens: auto;">{{alumno.calificacion.tareas_no_hechas}}</p>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
export default {
    props: ['parametros', 'users', 'fechaModificacion', 'hoy', 'rubros'],
    data(){
        return{
            numCabecera: '',
            loadingDescarga: null,
            descargaVisible: false,
            paginasAlumnos: []
        }
    },
    methods: {
        
        getNumTotalCabecera(){
                            
            const vm = this
            const cabecera = []
            if(vm.rubros.calificacion == 'si'){
                cabecera.push('calificacion')
            }
            if(vm.rubros.faltas == 'si'){
                cabecera.push('faltas')
            }
            if(vm.rubros.conducta == 'si'){
                cabecera.push('conducta')
            }
            if(vm.rubros.retardos == 'si'){
                cabecera.push('retardos')
            }
            if(vm.rubros.tareas_no_hechas == 'si'){
                cabecera.push('tareas_no_hechas')
            }
            vm.numCabecera = cabecera.length
        },
        getPageAlumnos(){
            if(this.users && this.users.alumnos && this.users.alumnos.length){
                const array = []
                const paginas = this.users
                const limite = 40
                for(let i = 0; i < paginas.alumnos.length; i += limite){
                    const page = paginas.alumnos.slice(i, i + limite)
                    const obj = {
                        params_calificacion: paginas.params_calificacion,
                        alumnos: page,
                        clases_impartidas: paginas.clases_impartidas
                    }
                    array.push(obj)
                }
                this.paginasAlumnos = array
            }
        },
    
        loadingProgreso(num){
        this.loadingDescarga = this.$vs.loading({
            text: 'No cierre la ventana. Generando PDF: ' + num + '%'
        });
        },
        
        async getGenerarPDFActas() {
            this.loadingProgreso(0)
        try {
            this.descargaVisible = true;
            setTimeout(()=>{
                this.generateAndDownloadPDF()
            }, 500)
        } catch (error) {
            console.log(error)
        }
        // pdf.save(pdfFileName)
        // this.descargaVisible = false;
        // this.loadingDescarga.close()
        },
        async generateAndDownloadPDF() {
            // Crea un nuevo objeto jsPDF
            const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'letter',
            compress: true,
            fontSize: 12,
            lineHeight: 1.2,
            setMargins: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }
            });

            // Nombre del archivo PDF
            const pdfFileName = this.users.params_calificacion.docente + '.pdf';
            // Itera sobre los elementos y agrega cada página al PDF
        
            const pages = document.querySelectorAll('.DescargarActaCalificacionesDocente');
            for (let i = 0; i < pages.length; i++) {
                //Muestra el prograso en el loading
                this.loadingDescarga.close()
                this.loadingProgreso(Math.round(i / pages.length * 100))

                const pageContent = pages[i];

                // Genera y agrega la página al PDF
                await this.addPageToPDF(pdf, pageContent, i + 1, pages.length);

                // Agrega una nueva página al PDF (excepto en la última iteración)
                if (i < pages.length - 1) {
                pdf.addPage();
                }
            }
            // Guarda o abre el PDF
            pdf.save(pdfFileName)
            this.descargaVisible = false;
            this.loadingDescarga.close()
        },
        async addPageToPDF(pdf, pageContent, pageNumber, totalPages) {
            // Usa html2canvas para capturar el contenido como una imagen
            const canvas = await html2canvas(pageContent, {
                scale: 1, // Ajusta la escala para mejorar la calidad
                quality: 0.1, // Ajusta la calidad de la imagen
                });

            // Convierte la imagen del canvas a datos URL
            const imageData = canvas.toDataURL("image/png");
            
            // Agrega la imagen al PDF
            pdf.addImage(imageData, "PNG", 3, 3, 210, 285, '', 'FAST', 'SLOW');

            // Agrega el número de página en la parte inferior de la página
            pdf.setFontSize(6);
            pdf.text(`Página ${pageNumber} de ${totalPages}`, pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() - 10, {
                align: 'center'
            });
        },
        ////////////////////////////////////////////////////////////////
        
        // async generateAndDownloadPDF() {
        //     const pdf = new jsPDF({
        //         orientation: 'portrait',
        //         unit: 'mm',
        //         format: 'letter',
        //         compress: true,
        //         setMargins: {
        //             top: 0,
        //             right: 0,
        //             bottom: 0,
        //             left: 0
        //         }
        //     });
        //     const pdfFileName = this.users.params_calificacion.docente + '.pdf';
        
        //     const elementToCapture  = document.querySelectorAll('.DescargarActaCalificacionesDocente');
        //     const canvas = await html2canvas(elementToCapture[0], {
        //         scale: 1,
        //         useCORS: true,
        //     });
        //     const imageData = canvas.toDataURL('image/jpeg');
        //     pdf.addImage(imageData, "JPEG", 3, 3, 210, 285, '', 'FAST');
        //     pdf.save(pdfFileName);
            
        //     setTimeout(()=>{
        //         this.descargaVisible = false;
        //         this.loadingDescarga.close();
        //     }, 1000);
        // },
    },
    watch:{
        users(){
            this.getNumTotalCabecera()
            this.getPageAlumnos()
        }
    }
}
</script>
<style scoped>
.objetfit > img{
	width: 1240px;
	height: 150px;
	object-fit: cover;
}
.fontTen{
    font-size: 12px;
}
.fontSix{
    font-size: 13px;
}
.fontEight{
    font-size: 15px;
}
.fontNine{
    font-size: 16px;
}
.cabeceraTable{
    font-weight: 500;
    line-height: 1.5;
}
.cabeceraTableCenter{
    font-weight: 500;
    line-height: 1.5;
    text-align: center;
}
p{
    margin-bottom: 0;
}
.lineTogether {
    line-height: 1.5;
}
table tr th{
    font-size: 7px;
    margin: 0 2px;
}
.widthCabecera2{
    width: 50%;
}
.widthCabecera3{
    width: 33.3%;
}
.widthCabecera4{
    width: 25%;
}
.widthCabecera5{
    width: 20%;
}
.widthCabecera6{
    width: 16.6%;
}
.widthCabecera7{
    width: 14.28%;
}
.widthCabecera8{
    width: 12.5%;
}
.widthCabecera9{
    width: 11.11%;
}
.widthCabecera10{
    width: 10%;
}
.widthCabecera11{
    width: 9%;
}
.widthCabecera12{
    width: 8.33%;
}
.widthCabecera13{
    width: 7.69%;
}
.widthCabecera14{
    width: 7.14%;
}
.widthCabecera15{
    width: 6.66%;
}
.widthCabecera16{
    width: 6.25%;
}
.lineSeparadorCampoFormativo{
    width: 100%;
    height: 1px;
    background: #D9D9D9;
    margin: 2px 0;
}
.lineSeparador{
    width: 99.5%;
    height: 1px;
    background: #D9D9D9;
    margin: 2px 0 2px 0.5%;
}
.backgroundCampos:nth-last-child(even){
    background: rgba(217, 217, 217, 0.6);
}
.bottom-div {
    position: absolute;
    bottom: 35px;
    width: 1240px;
    text-align: center;
}
.padding9{
    padding: 0 9px;
}
.fs-18{
    font-size: 18px;
}
.fw-bold{
    font-weight: bold;
}
</style>